import { type RouteLocationNormalized } from 'vue-router';

export type RouteWithQuery = Pick<RouteLocationNormalized, 'query'>;

export function isFeatureEnabled(key: SupportedFeatures, route: RouteWithQuery): boolean {
  const featuresFromRoute = getFeaturesFromRoute(route);

  return featuresFromRoute.includes(key);
}

function getFeaturesFromRoute(route: RouteWithQuery): string[] {
  const features = (route?.query?.feature || '') as string;

  return features.split(',').map((feature) => feature.trim());
}

export enum SupportedFeatures {
  RENOVATION_PLANNER = 'renovationPlanner',
  NEW_VALUATION_MODEL = 'newValuationModel',
}
